"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SSMAwareHttpClient_1 = require("../Http/SSMAwareHttpClient");
const ContainerParams_1 = require("../Enum/ContainerParams");
class ServiceAlterCompilerPass {
    /**
     * @inheritDoc
     */
    process(container) {
        const args = container.getDefinition("http_client")
            .setClass(SSMAwareHttpClient_1.SSMAwareHttpClient)
            .getArguments();
        args.push("@cookie");
        args.push(`%${ContainerParams_1.ContainerParams.COOKIE_DOMAIN}`);
    }
}
exports.default = ServiceAlterCompilerPass;
